import React from 'react';
import { useTranslation } from 'react-i18next';

import { H5 } from '../../components/Typography';
import useForm from '../../utils/useForm';
import AddressForm from '../../components/Forms/AddressForm';
import PaymentMethodForm from '../../components/Forms/PaymentMethodForm';

interface IProps {
  onSubmit: (values: FormNewPaymentMethod) => void;
}

export default ({ onSubmit }: IProps): React.ReactElement => {
  const { t } = useTranslation();
  const { values, handleChange } = useForm<FormNewPaymentMethod>({
    initialValues: {
      cardNumber: '',
      expDate: '',
      securityCode: '',
      cardFirstName: '',
      cardLastName: '',
      country: '',
      province: '',
      firstName: '',
      lastName: '',
      company: '',
      address1: '',
      address2: '',
      city: '',
      zip: '',
      phone: '',
    },
  });

  const handleOnSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(values);
  };

  return (
    <form
      id="new-payment-method-form"
      className="bundle-add-payment-method"
      onSubmit={handleOnSubmit}
    >
      <H5 modifiers={['body', 'emphasis']}>
        {t('new_payment_method.payment_info')}
      </H5>
      <br />
      <PaymentMethodForm handleChange={handleChange} values={values} />
      <H5 modifiers={['body', 'emphasis']}>
        {t('new_payment_method.billing_address')}
      </H5>
      <br />
      <AddressForm handleChange={handleChange} values={values} />
    </form>
  );
};
